import produce from 'immer';

import {
  CHARGE_CODE_FETCH_FAILURE,
  CHARGE_CODE_FETCH_REQUEST,
  CHARGE_CODE_FETCH_SUCCESS,
  CHARGE_CODES_FETCH_FAILURE,
  CHARGE_CODES_FETCH_REQUEST,
  CHARGE_CODES_FETCH_SUCCESS,
} from '@actions/chargeCode';

const initialState: IChargeCodeStore = {
  currentChargeCode: null,
  chargeCodes: null,
  error: null,
};

export default (state: IChargeCodeStore = initialState, action: any) =>
  produce(state, (draftState: IChargeCodeStore) => {
    switch (action.type) {
      case CHARGE_CODES_FETCH_REQUEST:
        draftState.error = null;

        return;
      case CHARGE_CODES_FETCH_SUCCESS:
        draftState.chargeCodes = action.response;
        draftState.error = null;

        return;
      case CHARGE_CODES_FETCH_FAILURE:
        draftState.chargeCodes = null;
        draftState.error = action.error;

        return;
      case CHARGE_CODE_FETCH_REQUEST:
        draftState.currentChargeCode = null;
        draftState.error = null;

        return;
      case CHARGE_CODE_FETCH_SUCCESS:
        draftState.currentChargeCode = action.response;
        draftState.error = null;

        return;
      case CHARGE_CODE_FETCH_FAILURE:
        draftState.currentChargeCode = null;
        draftState.error = action.error;

        return;
    }
  });
